import {
    CloseIcon,
    Divider,
    Dropdown,
    Flex,
    Input,
    Loader,
    SearchIcon,
    Text,
} from "@fluentui/react-northstar";
import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { getAllUser } from "../../../features/new_dashboard/api";
import { debounce } from "../../../utils/global";
import { DEBOUNCE_DELAY } from "../constant";
import { AVATAR_DEFAULT } from "../../../constants";
import { Search28Regular } from "@fluentui/react-icons";
import styled from "styled-components";
import { DEVICE } from "../../../constants/responsive";
import { getAllOnboardingUser } from "../api";

const OnboardingSearchBar = ({
    userIdSelected,
    AgencyId,
    setUserIdSelected,
}) => {
    const [users, setUsers] = useState("");
    const [items, setItems] = useState([]);
    const [refresh, setRefresh] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);
    const [searchquery, setSearchQuery] = useState("");
    const {
        data: all_users,
        isLoading,
        isFetching,
        refetch,
    } = useQuery(
        ["getAllUser", AgencyId],
        () => {
            return getAllOnboardingUser(AgencyId);
        },
        {
            enabled: AgencyId !== null,
            refetchOnWindowFocus: false,
            onSuccess: () => {
                return setRefresh(new Date().getTime());
            },
        }
    );

    if (isLoading || isFetching) {
        <Loader label="Chargement des collaborateurs..." />;
    }

    const handleChange = debounce((e) => {
        if (e?.target?.value?.length > 0) {
            setSearchQuery(e.target.value);
        }
        if (e?.target?.value?.length <= 2) {
            return;
        } else {
            setUsers(e.target.value);
        }
        return;
    }, DEBOUNCE_DELAY);

    useEffect(() => {
        if (!all_users?.error) {
            const data = all_users?.map((el) => {
                return {
                    header: el?.name,
                    image: el?.avatar || AVATAR_DEFAULT,
                    // content: el?.job_title || "/",
                    // detail: el,
                    id: el?.id,
                    key: el?.id,
                };
            });
            setItems(data ?? []);
        }
    }, [refresh]);

    useEffect(() => {
        setUsers("");
        setItems([]);
        setUserIdSelected(null);
        setSelectedItem(null);
    }, [AgencyId]);

    if (isLoading || isFetching) {
        return <Loader label="chargement" />;
    }

    return (
        <Flex fill hAlign="center">
            <DropdownStyled
                fluid
                search
                items={items ?? []}
                value={selectedItem}
                placeholder="Rechercher un collaborateur"
                loading={isLoading || isFetching}
                noResultsMessage={
                    all_users ? (
                        "Aucun résultat trouvé."
                    ) : (
                        <Text content="Chargement..." />
                    )
                }
                itemToString={(e) => {
                    if (e) {
                        return e?.header;
                    } else {
                        return "";
                    }
                }}
                a11ySelectedItemsMessage="Press Delete or Backspace to remove"
                inverted
                toggleIndicator={
                    <Flex>
                        <Divider
                            style={{
                                width: "10px",
                                height: "30px",
                                marginRight: "16px",
                            }}
                            vertical
                        />
                        {userIdSelected !== null && searchquery.length > 0 ? (
                            <CloseIcon
                                size="large"
                                style={{
                                    color: "#5B5FC7",
                                    marginTop: "5px",
                                }}
                                onClick={() => {
                                    setSearchQuery("");
                                    setSelectedItem(null);
                                    setUserIdSelected(null);
                                }}
                            />
                        ) : (
                            <Search28Regular style={{ color: "#5B5FC7" }} />
                        )}
                    </Flex>
                }
                onChangeCapture={(e) => handleChange(e)}
                // onChange={() => navigate(`/employee/${all_users[0].id}`)}
                onChange={(e, data) => {
                    setSelectedItem(data?.value ?? null);
                    if (data?.value?.id) {
                        // navigate(`/onboarding/detail/${data.value.id}`);
                        setUserIdSelected(data?.value?.id);
                    } else {
                        setUserIdSelected(null);
                    }
                }}
            />
        </Flex>
    );
};

export default OnboardingSearchBar;

const DropdownStyled = styled(Dropdown)`
    border-radius: 16px;
    border: 1px solid #d1d1d1;
    background: #fff;
    /* width: 100%; */
    align-items: center;
    display: flex;
    width: 900px;
    height: 50px;
    padding: 16px;
    /* border: none; */
    background: white;
    .ui-dropdown__container,
    .ui-dropdown__container:active,
    .ui-dropdown__container:hover {
        border-bottom-style: hidden; /* Ou border-bottom: none; */
        background-color: #fff;
    }
    /* .ui-dropdown__container .ui-dropdown__searchinput__input:focus {
        border-bottom-style: hidden;
    } */
`;
